import icon from '@material-ui/icons/Person'

const clientUuids = { icon, options: { label: 'ClientUuids' } }

export default clientUuids
